module.exports = __webpack_public_path__ + "static/media/javascript.e169ba29.svg";